module.exports = __webpack_public_path__ + "media/images/emblems/Dorneck-50cc17d1cd55c81a8e9dbfa5d6287db2.png";